import React, { useEffect } from 'react';
import { GlobalDisplayState } from '../../../context/types';
import { Segmentation } from '../../../types';
import { Segment } from '../filter/filterbar/types';
import { ItemsState } from '../filter/types';
import { SegmentationsToToolsSync } from './timeperiod/types';
import { GlobalDisplayActionWithGlobalDisplayState } from './types';

export const useChartWidth = () => {
  const chartContainerRef = React.useRef<HTMLDivElement>(null);
  const [chartWidth, setChartWidth] = React.useState<number | undefined>(undefined);

  React.useEffect(() => {
    if (!chartContainerRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (entry) {
        // Account for chart margins
        const containerWidth = entry.contentRect.width;
        const effectiveWidth = Math.max(containerWidth - 100, 0);
        setChartWidth(effectiveWidth);
      }
    });

    resizeObserver.observe(chartContainerRef.current);

    return () => resizeObserver.disconnect();
  }, []);

  return {
    chartContainerRef,
    chartWidth,
  };
};

export const useSyncGlobalDisplayState = (
  displayGlobalState: GlobalDisplayState,
  displayReducer: React.Dispatch<GlobalDisplayActionWithGlobalDisplayState>
) => {
  useEffect(() => {
    const action: GlobalDisplayActionWithGlobalDisplayState = {
      type: 'global-state-sync',
      globalDisplayState: displayGlobalState,
    };
    displayReducer(action);
  }, [displayGlobalState]);
};

export const useToggleToolsOnSegmentationChange = (
  segmentations: Segmentation[] | undefined,
  segmentationState: ItemsState<Segment>,
  displayReducer: React.Dispatch<SegmentationsToToolsSync>
) => {
  useEffect(() => {
    // This is necessary when segmentation is added by the user
    // resulting in a stacked bar chart
    const action: SegmentationsToToolsSync = {
      type: 'segmentations-to-tools-sync',
      segmentations,
    };
    displayReducer(action);
  }, [segmentationState.items.length]);
};
